import React from 'react';
import { View, Image } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Images, withTheme, LightThemeColors } from '../Themes';
import VFText from '../VFText';

import styles from './ErrorMessage.Styles';

const ErrorMessage = ({
  errorMessage,
  subErrorMessage = null,
  style,
  errorTextStyle,
  subErrorTextStyle,
  containerAccessibilityLabel,
  imageAccessibilityLabel,
  errorMessageAccessibilityLabel,
  subErrorMessageAccessibilityLabel,
  theme,
  ...props
}) => {
  return (
    <View
      style={[styles.container, style]}
      accessibilityLabel={containerAccessibilityLabel ?? FoundationTestKeys.warningParentView}
      testID={containerAccessibilityLabel ?? FoundationTestKeys.warningParentView}
      {...props}
    >
      <View
        style={styles.header}
        accessibilityLabel={FoundationTestKeys.warningView}
        testID={FoundationTestKeys.warningView}
      >
        <Image
          source={Images.ic_WarningNotification_White}
          style={styles.warning}
          accessibilityLabel={imageAccessibilityLabel ?? FoundationTestKeys.warningViewImage}
          testID={imageAccessibilityLabel ?? FoundationTestKeys.warningViewImage}
        />
      </View>
      <VFText
        style={[styles.errorMessage(theme), errorTextStyle]}
        testKey={errorMessageAccessibilityLabel ?? FoundationTestKeys.warningViewText}
        i18nKey={errorMessage}
      />
      {subErrorMessage ? (
        <VFText
          style={[styles.subErrorMessage(theme), subErrorTextStyle]}
          testKey={subErrorMessageAccessibilityLabel ?? FoundationTestKeys.warningViewSubText}
          i18nKey={subErrorMessage}
        />
      ) : null}
    </View>
  );
};

ErrorMessage.defaultProps = {
  theme: LightThemeColors,
};

ErrorMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  subErrorMessage: PropTypes.string,
  style: ViewPropTypes.style,
  errorTextStyle: TextPropTypes.style,
  subErrorTextStyle: TextPropTypes.style,
  containerAccessibilityLabel: PropTypes.string,
  imageAccessibilityLabel: PropTypes.string,
  theme: PropTypes.object,
  errorMessageAccessibilityLabel: PropTypes.string,
  subErrorMessageAccessibilityLabel: PropTypes.string,
};

export default withTheme(ErrorMessage);
